/*eslint-disable*/
import { Home, DollarSign, List, Send, Box, Info, Shield, User } from "react-feather";
import { useTranslation } from "react-i18next";
import { userContext } from "../../context/user";
import { USER_TYPES } from "../../resources/enums";
import useTwoFactorStatus from "../../hooks/user/useTwoFactorStatus";

// Estructura tomada de design/BlockPay - Rediseño.dc.html (array `nav`):
// Inicio · Transacciones · Transferir · Block Invest · Inversiones · FAQ
// [Cuenta] Perfil y 2FA
// [Términos y condiciones] Disclaimer · Política de privacidad
//
// Tres cambios respecto al menú anterior:
//   - "Inversiones" pasa de grupo colapsable (Resumen/Detalle) a item plano -> /investment
//   - se añade la sección "Cuenta" con Perfil y 2FA, que existía como ruta pero no en el menú
//   - las legales apuntan a /legal/:doc, la pantalla unificada con pestañas
//
// El diseño no distingue IBO de no-IBO; el código sí, y eso es permisos, no diseño,
// así que la distinción se mantiene. Se expresa como base + extras para no repetir.

const ICON_SIZE = 18; // el diseño usa iconos de 18px, no de 20

const Menu = () => {
	const { user } = userContext();
	const { enabled: hasTwoFactor } = useTwoFactorStatus();
	const { t } = useTranslation();

	const isIbo = user?.userTypeId === USER_TYPES.IBO;

	const base = [
		{
			id: "home",
			title: t("Home"),
			icon: <Home size={ICON_SIZE} />,
			navLink: "/home"
		},
		{
			id: "transactions",
			title: t("Transactions"),
			icon: <List size={ICON_SIZE} />,
			navLink: "/transactions"
		},
		{
			id: "transfer",
			title: t("Transfer"),
			icon: <Send size={ICON_SIZE} />,
			navLink: "/transfer"
		}
	];

	const iboOnly = [
		{
			id: "block-invest",
			title: t("Block Invest"),
			icon: <Box size={ICON_SIZE} />,
			navLink: "/block-invest"
		},
		{
			id: "invest",
			title: t("Investments"),
			icon: <DollarSign size={ICON_SIZE} />,
			navLink: "/investment"
		},
		{
			id: "faq",
			title: t("FAQ"),
			icon: <Info size={ICON_SIZE} />,
			navLink: "/faq"
		}
	];

	const account = [
		{
			header: t("Account")
		},
		{
			id: "profile",
			title: t("ProfileAndTwoFactor"),
			icon: <User size={ICON_SIZE} />,
			navLink: "/profile"
		}
	];

	const legal = [
		{
			header: t("TermsAndConditions")
		},
		{
			id: "disclaimer",
			title: t("Disclaimer"),
			icon: <Shield size={ICON_SIZE} />,
			navLink: "/legal/disclaimer"
		},
		{
			id: "privacity",
			title: t("Privacity"),
			icon: <Shield size={ICON_SIZE} />,
			navLink: "/legal/privacy"
		}
	];

	const menuItems = [
		...base,
		...(isIbo ? iboOnly : []),
		...account,
		...legal
	];

	// Sin verificación en dos pasos no hay menú, porque tampoco hay a dónde ir: el layout
	// retiene a la persona en el Perfil hasta que la active (ver layouts/VerticalLayout.js).
	// Pintar un menú cuyos enlaces devuelven todos al mismo sitio sería ofrecer salidas falsas.
	//
	// La exención de los empleados no se pierde: la resuelve `useTwoFactorStatus`, que es ahora
	// quien contesta esta pregunta para el menú y para el layout, con una sola consulta.
	return {
		menuItems: hasTwoFactor ? menuItems : []
	};
};

export default Menu;
